import type React from 'react';

export function PopoverContainer({ children }: { children: React.ReactNode }) {
    return <div className="flex h-fit min-w-76 max-w-76 flex-col overflow-hidden">{children}</div>;
}
